import { render, staticRenderFns } from "./behavior-stats.vue?vue&type=template&id=0345b7a8&scoped=true&"
import script from "./behavior-stats.vue?vue&type=script&lang=js&"
export * from "./behavior-stats.vue?vue&type=script&lang=js&"
import style0 from "./behavior-stats.vue?vue&type=style&index=0&id=0345b7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345b7a8",
  null
  
)

export default component.exports